import {load} from '@shopify/theme-sections';
import '../sections/product';
import '../sections/product-recommendations';
import '../components/product-tabs';
import ProductForm from '../components/ProductForm';
import ProductFormSimple from '../components/ProductFormSimple';
import React from 'react';
import ReactDOM from 'react-dom';
import 'nodelist-foreach-polyfill';
import {getSizedImageUrl} from '@shopify/theme-images';
import {formatMoney} from '@shopify/theme-currency';

document.addEventListener('DOMContentLoaded', () => {
  load('*');
});

const swatchesDataContainer = document.getElementById('SwatchesData');
const productDataContainer = document.getElementById('ProductVariantData');
const saddleOptionsDataContainer = document.getElementById('SaddleOptionsData');
const productFormContainer = document.getElementById('ProductForm');
const upsellsProductFormContainer = document.getElementById('UpsellProductForm');
const upsellsContainer = document.getElementById('PdpUpsells');

const productData = JSON.parse(productDataContainer.innerHTML);

/**
 * If ecommerce is disabled we want to make all variants available so that all
 * product options are visible to the customer.
 */
if (window.theme && window.theme.ecommerce === false) {
  productData.selectedVariant = {
    ...productData.selectedVariant,
    available: true,
  };
  productData.variants = productData.variants.map((variant) => {
    const newVariant = {
      ...variant,
      available: true,
    };
    return newVariant;
  });
}

const nestedSeparator = '||';

function mapOptionsBySku(optionNames, variant) {
  return optionNames.reduce((accum, opt, index) => {
    const nestedOptions = opt.split(nestedSeparator);
    const variantOptions = variant.options[index];

    if (nestedOptions.length === 1) {
      return {
        ...accum,
        [opt]: variantOptions,
      };
    }

    const optionsToUpdate = {};
    const nestedVariantOptions = variantOptions.split(nestedSeparator);

    nestedOptions.forEach((option, optIndex) => {
      optionsToUpdate[option] = nestedVariantOptions[optIndex];
    });

    return {
      ...accum,
      ...optionsToUpdate,
    };
  }, {});
}

function generateSkuGroup(data) {
  const optionNames = data.options.map((opt) => opt.name);
  return data.variants.reduce((accum, variant) => {
    const options = mapOptionsBySku(optionNames, variant);
    return {
      ...accum,
      [variant.sku]: options,
    };
  }, {});
}

function generateOptionTypeSummary(options) {
  const summary = [];
  options.forEach(({name, values}) => {
    const nestedOptionNames = name.split(nestedSeparator);
    if (nestedOptionNames.length === 1) {
      summary.push({
        name,
        values,
      });
      return;
    }
    nestedOptionNames.forEach((optionName, index) => {
      const optionValues = [];
      values.forEach((value) => {
        const valueName = value.split(nestedSeparator)[index];
        if (optionValues.includes(valueName)) { return; }
        optionValues.push(valueName);
      });
      summary.push({
        name: optionName,
        values: optionValues,
      });
    });
  });
  return summary;
}

function generateSkuGroupJson(data) {
  const skuGroup = generateSkuGroup(data);
  const optionTypeSummary = generateOptionTypeSummary(data.options);
  return {
    ...data.sku_group_json,
    option_type_summary: optionTypeSummary,
    sku_group: skuGroup,
  };
}

productData.sku_group_json = generateSkuGroupJson(productData);
const skuGroupJSON = productData.sku_group_json;
const productOptions = skuGroupJSON.option_type_summary;
if (productOptions && productOptions.length > 0) {
  productOptions.forEach((option) => {
    const productOptionData = [];
    option.values.forEach((value) => {
      productOptionData.push({
        name: value,
        isDisabled: false,
      });
    });
    option.values = productOptionData;
  });
}

const cartUpsells = window.cartUpsells || [];
const productID = window.productID || null;

/**
 * Get current products upsell products
 */
const currentUpsellProducts = cartUpsells.find(currentUpsell => {
  return currentUpsell.product.id === productID || currentUpsell.collectionProducts.some(product => product.id === productID);
});

/**
 * Get upsell product data that contains variants
 */
const upsellProductsWithVariants = currentUpsellProducts ? currentUpsellProducts.upsellProducts.filter((upsellProduct) => upsellProduct.variants.length > 1) : [];

/**
 * Get upsell product data that does not contain variants
 */
const upsellProductsWithoutVariants = currentUpsellProducts ? currentUpsellProducts.upsellProducts.filter((upsellProduct) => upsellProduct.variants.length < 2) : [];

class UpsellProductForms extends React.Component {
  constructor(props) {
    super(props);

  /**
   * If no upsells setup abort.
   */
    if (!currentUpsellProducts) {
      return;
    }

    this.state = {
      upsellsAdded: upsellProductsWithVariants.map(upsellProduct => {
        return {
          productId: upsellProduct.upsellProductData.productId,
          isAdded: false,
        };
      }),
    };

    this.updateUpsellState = this.updateUpsellState.bind(this);
  }

  updateUpsellState(productId) {
    this.setState((prevState) => {
      let upsellsAdded = prevState.upsellsAdded.map(upsellProduct => {
        if (upsellProduct.productId === productId) {
          return {
            productId: upsellProduct.productId,
            isAdded: true,
          };
        }
        return upsellProduct;
      });
      const allTrue = upsellsAdded.every(upsell => upsell.isAdded);
      if (allTrue) {
        document.body.classList.add('cart-is-visible');
        document.body.classList.remove('upsell__variant-modal--is-visible');
        document.body.classList.add('delay-upsell-modal');
        upsellsAdded.map(upsell => {
          upsell.isAdded = false;
          return upsell;
        });
      }
      return {upsellsAdded};
    });
  }

  render() {
    const Forms = upsellProductsWithVariants.map(upsellProduct => {

    /**
     * Structuring data to pass as props to upsell variant selection modal product form
     */
      const upsellProductData = upsellProduct.upsellProductData;
      if (!upsellProductData.sku_group_json) {
        upsellProductData.sku_group_json = generateSkuGroupJson(upsellProductData);
      }
      const upsellSkuGroupJSON = upsellProductData.sku_group_json;
      const upsellProductOptions = upsellSkuGroupJSON.option_type_summary;
      if (upsellProductOptions && upsellProductOptions.length > 0) {
        upsellProductOptions.forEach((option) => {
          const productOptionData = [];
          option.values.forEach((value) => {
            productOptionData.push({
              name: value.name ? value.name : value,
              isDisabled: false,
            });
          });
          option.values = productOptionData;
        });
      }

      let upsellAdded = false;
      const upsell = this.state.upsellsAdded.find(item => item.productId === upsellProductData.productId);
      upsellAdded = upsell && upsell.isAdded;

      return (
        <ProductForm
          key={upsellProductData.selectedVariant.id}
          title={upsellProductData.title}
          productId={upsellProductData.productId}
          variants={upsellProductData.variants}
          options={upsellProductOptions}
          initialVariant={upsellProductData.selectedVariant}
          skuGroup={upsellProductData.sku_group_json.sku_group}
          isUpsell={true}
          upsellAdded={upsellAdded}
          updateUpsellState={this.updateUpsellState}
        />
      );
    });

    return (
      <div>
        {Forms}
      </div>
    );
  }
}


class PdpUpsells extends React.Component {
  constructor(props) {
    super(props);

  /**
   * Check if is main product and do not render upsells if true
   */
    const isMainProductCheckVariants = upsellProductsWithVariants.every((upsell) => upsell.id !== productID);
    const isMainProductCheckNoVariants = upsellProductsWithoutVariants.every((upsell) => upsell.id !== productID);
    this.state = {
      isMainProductCheckVariants: isMainProductCheckVariants,
      isMainProductCheckNoVariants: isMainProductCheckNoVariants,
    };
  }

  render() {
    const {isMainProductCheckVariants, isMainProductCheckNoVariants} = this.state;
    const moreThanOneUpsellIsAvailable = cartUpsells.some(upsellProduct => {
      return upsellProduct.upsellProducts.some(product => {
        if (product.id === '') { return false; }
        if (product.upsellProductData.selectedVariant.available === true) {
          return true;
        }
        return false;
      });
    });

    const currentUpsellProducts = cartUpsells.find(currentUpsell => {
      return currentUpsell.product.id === productID || currentUpsell.collectionProducts.some(product => product.id === productID);
    });
    if (!currentUpsellProducts) { return null; }
    const PpdUpsells = currentUpsellProducts.upsellProducts.map((product, index) => {
      const upsellProductData = product.upsellProductData;
      return (
        <React.Fragment key={index}>
          {moreThanOneUpsellIsAvailable && isMainProductCheckVariants && isMainProductCheckNoVariants && (
            <a className="upsell__product--link-wrapper" href={upsellProductData.url}>
              {upsellProductData.selectedVariant.featured_image &&
                <img
                  className="upsell__product--image"
                  src={getSizedImageUrl(upsellProductData.selectedVariant.featured_image.src, '200x200_crop_center')}
                  alt={upsellProductData.title}
                />
              }
              <div className="upsell__product--info-wrapper">
                <h4 className="upsell__product--title">{upsellProductData.title}</h4>
                <span className="upsell__product--price-value">Valued at</span>
                <span className="upsell__product--price">{formatMoney(upsellProductData.price, window.theme.moneyFormat)}</span>
              </div>
            </a>
          )}
        </React.Fragment>
      );
    });

    return (
      <div className={PpdUpsells && PpdUpsells.length ? '' : 'hide'}>
        {PpdUpsells && PpdUpsells.length && isMainProductCheckVariants && isMainProductCheckNoVariants && (
          <>
            <div className="pdp__upsells--heading-wrapper">
              <h3>Free Gift{PpdUpsells.length > 1 ? 's' : ''}</h3>
            </div>
            <div className="pdp__upsells--wrapper">
              {PpdUpsells}
            </div>
          </>
        )}
      </div>
    );
  }
}


window.theme.swatches = JSON.parse(swatchesDataContainer.innerHTML);
window.theme.saddleOptions = JSON.parse(saddleOptionsDataContainer.innerHTML);
if (productFormContainer) {
  if (!productOptions) {
    ReactDOM.render(
      <ProductFormSimple
        variants={productData.variants}
        initialVariant={productData.selectedVariant}
      />,
      productFormContainer,
    );
  } else if (productOptions.length === 0) {
    ReactDOM.render(
      <ProductFormSimple
        variants={productData.variants}
        initialVariant={productData.selectedVariant}
      />,
      productFormContainer,
    );
  } else {
    ReactDOM.render(
      <ProductForm
        variants={productData.variants}
        options={productOptions}
        initialVariant={productData.selectedVariant}
        skuGroup={skuGroupJSON.sku_group}
        isUpsell={false}
        upsellAdded={false}
      />,
      productFormContainer,
    );
  }
}

if (upsellsProductFormContainer) {
  ReactDOM.render(
    <UpsellProductForms
      upsellProductsWithVariants={upsellProductsWithVariants}
    />,
    upsellsProductFormContainer,
  );
}

if (upsellsContainer) {
  ReactDOM.render(
    <PdpUpsells
      upsellProductsWithVariants={upsellProductsWithVariants}
      upsellProductsWithoutVariants={upsellProductsWithoutVariants}
    />,
    upsellsContainer,
  );
}
